import { withInstall } from '../../../utils/with-install'
import ElasticMarker from './ElasticMarker.vue'

export const ElAmapElasticMarker = withInstall(ElasticMarker)
export default ElAmapElasticMarker
